const PRODUCTSEARCH_GET_REQUEST = 'PRODUCTSEARCH_GET_REQUEST';
const PRODUCTSEARCH_GET_SUCCESS = 'PRODUCTSEARCH_GET_SUCCESS';
const PRODUCTSEARCH_GET_ERROR = 'PRODUCTSEARCH_GET_ERROR';
const PRODUCTSEARCHDETAIL_GET_SUCCESS = 'PRODUCTSEARCHDETAIL_GET_SUCCESS';
const PRODUCTSEARCHDETAIL_GET_ERROR = 'PRODUCTSEARCHDETAIL_GET_ERROR';
const RESET_PRODUCTSEARCH_RESULTS = 'RESET_PRODUCTSEARCH_RESULTS';

export default {
    PRODUCTSEARCH_GET_REQUEST,
    PRODUCTSEARCH_GET_SUCCESS,
    PRODUCTSEARCH_GET_ERROR,
    PRODUCTSEARCHDETAIL_GET_SUCCESS,
    PRODUCTSEARCHDETAIL_GET_ERROR,
    RESET_PRODUCTSEARCH_RESULTS,
};
